module.exports = __webpack_public_path__ + "files/a7e7cda5f64c397aa84a462834aa8e05.png";